import React, { useEffect, useState } from 'react';
import api from '../services/api';
import AppearanceSettings from '../components/AppearanceSettings';

interface KpiTarget {
  id: number;
  kpi_code: string;
  target_value: number;
  description: string;
}

const SettingsPage: React.FC = () => {
  const [targets, setTargets] = useState<KpiTarget[]>([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState<number | null>(null);

  useEffect(() => {
    fetchTargets();
  }, []);

  const fetchTargets = async () => {
    try {
      const response = await api.get('kpi-targets/');
      const sortedTargets = response.data.sort((a: KpiTarget, b: KpiTarget) => 
        a.kpi_code.localeCompare(b.kpi_code)
      );
      setTargets(sortedTargets);
    } catch (error) {
      console.error("Error fetching targets", error);
    } finally {
      setLoading(false);
    }
  };

  const handleValueChange = (id: number, newValue: string) => {
    setTargets(prev => prev.map(t => 
      t.id === id ? { ...t, target_value: parseFloat(newValue) || 0 } : t
    ));
  };

  const handleSave = async (target: KpiTarget) => {
    setSavingId(target.id);
    try {
      await api.patch(`kpi-targets/${target.id}/`, 
        { target_value: target.target_value }
      );
      setTimeout(() => setSavingId(null), 1000);
    } catch (error) {
      console.error("Error updating target", error);
      alert('Erro ao atualizar meta.');
      setSavingId(null);
    }
  };

  if (loading) return <div style={{ padding: '20px' }}>Carregando configurações...</div>;

  return (
    <div>
      <div style={{ marginBottom: '30px' }}>
        <h1>Configurações</h1>
        <p style={{ color: 'var(--text-secondary)' }}>
          Defina as metas, aparência e parâmetros do sistema.
        </p>
      </div>

      <div style={{ display: 'grid', gap: '30px' }}>
        <AppearanceSettings />

        <div className="card">
          <h3>Metas de KPI</h3>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
            Ajuste os valores alvo para cada indicador de desempenho.
          </p>
          
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '15%' }}>Código</th>
                <th style={{ width: '50%' }}>Descrição do Indicador</th>
                <th style={{ width: '20%' }}>Meta Atual</th>
                <th style={{ width: '15%', textAlign: 'right' }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {targets.map((target) => (
                <tr key={target.id}>
                  <td>
                    <span className="badge badge-info" style={{ fontSize: '0.8rem' }}>
                      {target.kpi_code}
                    </span>
                  </td>
                  <td style={{ color: 'var(--text-main)', fontWeight: '500' }}>
                    {target.description}
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input 
                        type="number" 
                        step="0.1"
                        value={target.target_value}
                        onChange={(e) => handleValueChange(target.id, e.target.value)}
                        style={{ 
                          width: '100px', 
                          padding: '8px',
                          fontWeight: 'bold',
                          color: 'var(--primary-blue)'
                        }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <button 
                      className={`btn ${savingId === target.id ? 'btn-success' : 'btn-secondary'}`}
                      onClick={() => handleSave(target)}
                      disabled={savingId === target.id}
                      style={{ 
                        minWidth: '80px',
                        backgroundColor: savingId === target.id ? 'var(--success)' : '',
                        color: savingId === target.id ? 'white' : ''
                      }}
                    >
                      {savingId === target.id ? 'Salvo!' : 'Salvar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
